import {
  CampaignTypesKey,
  GlobalListPageKey,
  GlobalPageHeaderKey,
  TableTypesKey,
  UtilsTypesKey
} from 'utils/globalTranslation/TModules';

export const translations = {
  [GlobalListPageKey]: {
    RequestHasBeenApproved: 'La demande a été approuvée',
    RequestHasBeenDeleted: 'La demande a été supprimée',
    RequestHasBeenDenied: 'La demande a été refusée',
    RequestHasBeenCancelled: 'La demande a été annulée',
    RequestsHaveBeenApproved: 'Les demandes ont été approuvées',
    ThisFieldIsRequired: 'Ce champ est requis',
    SomethingWentWrong: 'Une erreur est survenue',
    Edit: 'Éditer',
    Maker: 'Créateur',
    Checker: 'Vérificateur',
    Cancel: 'Annuler',
    Confirm: 'Confirmer',
    NoData: 'Aucune Donnée',
    Day: 'jour',
    Week: 'semaine',
    Month: 'mois',
    Year: 'an',
    Days: 'jours',
    Weeks: 'semaines',
    Months: 'mois',
    Required: 'Obligatoire',
    MinValue: 'Doit être une valeur positive et au moins {{min}}',
    MaxValue: 'Ne doit pas être supérieur à {{max}}',
    MustBeInteger: 'Doit être une valeur entière',
    MustBeNumber: 'Doit être un nombre',
    InvalidEmail: 'Adresse e-mail invalide',
    InvalidUrl: 'URL invalide',
    NotGreaterThanUserLimit: 'La valeur ne doit pas dépasser la limite utilisateur',
    NotGreaterThanRewardLimit: 'La valeur ne doit pas dépasser la limite de récompense',
    ValueMustBePositive: 'La valeur doit être positive',
    ValueMustBeMoreThanZero: 'La valeur doit être strictement supérieure à zéro',
    InvalidCsvXlsx:
      'Seuls les fichiers .xlsx/.csv sont acceptés ; le type de fichier envoyé est invalide.',
    OnlyImageTypes: 'Vous ne pouvez importer que des fichiers JPG/JPEG/PNG/SVG !',
    SvgUnprocessable: 'Le fichier SVG est inutilisable !'
  },
  [GlobalPageHeaderKey]: {
    RewardRequest: 'Demande de récompense'
  },
  [CampaignTypesKey]: {
    AllCampaigns: 'Toutes Les Campagnes',
    InstantReward: 'Récompense instantanée',
    Stamp: 'Timbre',
    Game: 'Jeu',
    Quiz: 'Quiz',
    Survey: 'Sondage',
    Quest: 'Quête',
    Progress: 'Progrès',
    Raffle: 'Tirage au sort',
    Streak: 'Série',
    AllGames: 'Tous Les Jeux',
    SpinTheWheel: 'Tourner La Roue',
    ShakeTheTree: 'Secoue L’Arbre',
    HitThePinata: 'Frappe La Piñata',
    ScratchCard: 'Carte À Gratter',
    Plinko: 'Plinko',
    BubblePop: 'Pop De Bulles',
    Reward: 'Récompense',
    Referral: 'Parrainage',
    TeamProgress: 'Progrès D’Équipe',
    MultipleRuleCampaign: 'Campagne À Règles Multiples',
    Generic: 'Générique',
    RuleTriggerDays: 'Jours de déclenchement de la règle',
    TriggerDays: 'Jours de déclenchement',
    TriggerOnSpecificDays: 'Déclencher certains jours',
    HoverMe: 'Survolez-moi',
    From: 'De',
    To: 'À',
    SelectDays: 'Sélectionner les jours',
    SelectTime: "Sélectionner l'heure",
    Campaign: 'Campagne',
    Points: 'Points',
    Cashback: 'Cashback',
    Voucher: 'Bon',
    Batch: 'Lot',
    PrizeSet: 'Ensemble de prix',
    LoyaltyCurrency: 'Devise de fidélité',
    Rewards: 'Récompenses',
    Audience: 'Audience',
    UpdateCustomerDetails: 'Mettre à jour les informations client',
    PushEventOnly: 'Pousser uniquement l’événement'
  },
  [UtilsTypesKey]: {
    Monday: 'Lundi',
    Tuesday: 'Mardi',
    Wednesday: 'Mercredi',
    Thursday: 'Jeudi',
    Friday: 'Vendredi',
    Saturday: 'Samedi',
    Sunday: 'Dimanche',
    January: 'Janvier',
    February: 'Février',
    March: 'Mars',
    April: 'Avril',
    May: 'Mai',
    June: 'Juin',
    July: 'Juillet',
    August: 'Août',
    September: 'Septembre',
    October: 'Octobre',
    November: 'Novembre',
    December: 'Décembre'
  },
  [TableTypesKey]: {
    PerPage: '/ page',
    GoTo: 'Aller à',
    Page: 'Page',
    PreviousPage: 'Page précédente',
    NextPage: 'Page suivante',
    NoData: 'Aucune donnée'
  }
};
